<script setup lang="ts">
import { onBeforeMount, onBeforeUpdate, onMounted, ref, watch } from 'vue'
import { useWindowSize } from '@vueuse/core'
import watermark from '@/utils/watermark'
import type { IWatermarkOptions } from '@/utils/watermark'

const props = withDefaults(
  defineProps<
    Partial<Omit<IWatermarkOptions, 'text'>> & {
      text: string
    }
  >(),
  {
    family: 'SimSun',
  }
)

const el = ref<HTMLDivElement>()
const src = ref('')
const { width, height } = useWindowSize()

const canvas = document.createElement('canvas')

async function generate() {
  watermark(canvas, {
    ...props,
    width: props.width || el.value?.offsetWidth || 0,
    height: props.height || el.value?.offsetHeight || 0,
  })
  src.value = canvas.toDataURL('image/png')
  console.log('watermark generated')
}

watch([props, width, height], generate, { deep: true })
onMounted(() => {
  generate()
}
)

onBeforeMount(() => {
  // console.log("watermark.vue onBeforeMount 更新 CSP:", window.location.pathname);
  // if (window.__DYNAMIC_CSP__) {
  //   const currentPath = window.location.pathname;
  //   const requiredPolicy = "img-src 'self' data:;";
    
  //   if (window.__DYNAMIC_CSP__.findPolicy(currentPath) !== requiredPolicy) {
  //     window.__DYNAMIC_CSP__.updatePolicy("/nocsp");
  //     //window.location.reload(); // 确保 CSP 完全生效
  //   }
  // }
})

function reloadAllImages() {
  document.querySelectorAll('img').forEach(img => {
    const originalSrc = img.src;
    img.src = '';
    setTimeout(() => img.src = originalSrc, 50);
  });
}

</script>

<template>
  <div class="watermark" ref="el">
    <div class="watermark-bg" :style="{ backgroundImage: `url(${src})` }" />
    <div style="position: relative; z-index: 1; height: 100%">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.watermark {
  position: relative;

  &-bg {
    background-repeat: no-repeat;
    background-position: center;
    display: block;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
  }
}
</style>
